import Vue from 'vue'
import VideoBackground from 'vue-responsive-video-background-player'
Vue.component('VideoBackground', VideoBackground)
